import { useCallback } from 'react';
import { appendParams, finalizeUrl, getDefaultDeeplink } from '../../utils';
import { useOpenDeeplink } from '../../../../hooks';

export const useMoveToRecentlyViewedGoods = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(() => {
    const url = getDefaultDeeplink();
    appendParams(url, 'screen', 'RecentlyViewedGoods');
    openDeeplink(finalizeUrl(url));
  }, [openDeeplink]);
};